import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * ログイン履歴確認・更新API
 * ログイン履歴テーブルに自分の会員番号のレコードが存在するかどうかを確認し、
 * 履歴の有無を問わず新規にレコードを挿入する。
 * レスポンスとして、履歴が既に存在していたかどうかを返す。
 */
export namespace ApiTaLi180 {
  // API Name
  export const name: string = 'ApiTaLi180'

  // POST parameters
  export namespace Post {
    export const path: string = '/ta/loginHistory'

    export interface Request {}

    export interface Response {
      hasHistory: boolean
    }
  }

  // API本体
  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    /**
     * ログイン履歴を確認・更新する
     * @param _params リクエストパラメータ（空オブジェクト）
     * @param successHandler 成功時のハンドラ
     * @param errorHandler エラー時のハンドラ
     * @returns ハンドラの戻り値またはnull
     */
    public post<R>(
      _params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Post.Response = {
        hasHistory: false,
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(Post.path),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
